import {IApiRoster, IApiRosterHistoryEvent} from "../typings/apiResponse";
import {IApiEndpoints} from "../typings/apiEndpoints";
import * as angular from "angular";

export class RosterResource {
    public static $inject = ["$http", "ApiEndpoints"];
    constructor(private $http:angular.IHttpService,
                private ApiEndpoints:IApiEndpoints) {

    }

    /**
     * Gets a roster.
     * @param leagueId
     * @param teamId
     * @returns {IPromise<ngLeague.Roster>}
     */
    public getRoster(leagueId: number, teamId: number): angular.IPromise<IApiRoster> {
        return this.$http.get(`${this.ApiEndpoints.league}/${leagueId}/rosters/${teamId}`)
            .then((rostersResponse: angular.IHttpPromiseCallbackArg<IApiRoster>) => {
                return rostersResponse.data;
            });
    }

    /**
     * Gets roster history.
     * @param leagueId
     * @param teamId
     * @returns {IPromise<ngLeague.RosterHistoryEvent[]>}
     */
    public getRosterHistory(leagueId: number, teamId: number): angular.IPromise<IApiRosterHistoryEvent[]> {
        return this.$http.get(`${this.ApiEndpoints.league}/${leagueId}/rosters/${teamId}/history`)
            .then((rosterHistoryResponse: angular.IHttpPromiseCallbackArg<IApiRosterHistoryEvent[]>) => {
                return rosterHistoryResponse.data;
            });
    }

    /**
     * Add player to roster.
     * @param leagueId
     * @param teamId
     * @param playerId
     * @returns {IHttpPromise<any>}
     */
    public addPlayer(leagueId: number, teamId: number, playerId: number): angular.IPromise<any> {
        return this.$http.put(`${this.ApiEndpoints.league}/${leagueId}/rosters/${teamId}/members/${playerId}`, {});
    }

     /**
      * Remove player from roster
      * @param leagueId
      * @param teamId
      * @param playerId
      * @returns {IHttpPromise<any>}
      */
    public removePlayer(leagueId: number, teamId: number, playerId: number): angular.IPromise<any> {
        return this.$http.delete(`${this.ApiEndpoints.league}/${leagueId}/rosters/${teamId}/members/${playerId}`);
    }
}
